import React from 'react';
import { IconCircleCheckFilled, IconShoppingCart } from '@tabler/icons-react';
import { formatCents } from '@src/common';
import { useTranslate, useWidgetsTheme as theme } from '@src/core/hooks';
import { GradientButton } from '@src/components/reusable';
import useBreakpoint from '@src/hooks/useBreakpoint';
import { Container } from './styles';

interface CompletedSummaryProps {
  description: string;
  totalCents: number;
  onAddToCart: () => void;
}

const CompletedSummary = ({ description, totalCents, onAddToCart }: Readonly<CompletedSummaryProps>) => {
  const { i18n } = useTranslate();
  const actionColor = theme('actionColor');
  const { isDesktop } = useBreakpoint();

  return (
    <Container>
      <strong>{description}</strong>
      <IconCircleCheckFilled size={32} color={actionColor} />
      <p>
        {i18n('product_package_adder_total')}: {formatCents(totalCents)}
      </p>
      <GradientButton
        actionColor={actionColor}
        onClick={onAddToCart}
        fullWidth={!isDesktop}
        dataCy='multiProductBookingAddToCartButton'
      >
        <>
          {i18n('product_package_adder_add_to_cart_button')}
          <IconShoppingCart size={20} />
        </>
      </GradientButton>
    </Container>
  );
};

export default CompletedSummary;
